import React, { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { Button } from '@cld/button';
import useHover from '@cld/use-hover';
import {
  CookbookTransformationCard as BaseCookbookTransformationCard,
  CookbookTransformationCardProps as BaseCookbookTransformationCardProps,
} from '../../common';
import { messages } from '../../i18n';

const FooterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: ${globalTheme.spacing.sm};
`;

export interface TransformationCardProps extends Omit<BaseCookbookTransformationCardProps, 'hoverProps' | 'footerPanel'> {
  onReadMoreClick: () => void;
}

export const TransformationCard: FC<React.PropsWithChildren<TransformationCardProps>> = ({ onReadMoreClick, ...restProps }) => {
  const hoverProps = useHover();
  const footerPanel = useMemo(
    () => (
      <FooterWrapper>
        <Button data-test="button-read-more" size="sm" onClick={onReadMoreClick}>
          <FormattedMessage {...messages['pages.list.view-recipe']} />
        </Button>
      </FooterWrapper>
    ),
    [onReadMoreClick]
  );

  return <BaseCookbookTransformationCard hoverProps={hoverProps} footerPanel={footerPanel} {...restProps} />;
};
